module.exports = __webpack_public_path__ + "static/media/sun-cloud-rain.5a50429d.png";